import './QdRadioButton.scss';
import template from './QdRadioButton.vhtml';

export default {
	name: 'QdRadioButton',
	template: template,
	props: ['value', 'radioValue', 'name'],
	data: () => ({}),
	computed: {
		isSelected: vm => vm.value === vm.radioValue,
		buttonClasses: vm => {
			let dynamicClasses = {
				'qd-radio-button--selected': vm.isSelected,
			};

			return ['qd-radio-button', dynamicClasses];
		}
	},
	methods: {
		updateData() {
			this.$emit('input', this.radioValue);
		}
	},
};
